export default __webpack_public_path__ + "static/media/fashion.db6adec2.png";